// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnimatedNumberController from "./animated_number_controller"
application.register("animated-number", AnimatedNumberController)

import AutoNavigateController from "./auto_navigate_controller"
application.register("auto-navigate", AutoNavigateController)

import CardCarouselController from "./card_carousel_controller"
application.register("card-carousel", CardCarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import EventsController from "./events_controller"
application.register("events", EventsController)

import FakeProgressController from "./fake_progress_controller"
application.register("fake-progress", FakeProgressController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PreserveXScrollController from "./preserve_x_scroll_controller"
application.register("preserve-x-scroll", PreserveXScrollController)

import RadioButtonController from "./radio_button_controller"
application.register("radio-button", RadioButtonController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollToRightController from "./scroll_to_right_controller"
application.register("scroll-to-right", ScrollToRightController)

import ScrollrevealController from "./scrollreveal_controller"
application.register("scrollreveal", ScrollrevealController)

import SelfDestructController from "./self_destruct_controller"
application.register("self-destruct", SelfDestructController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SlugController from "./slug_controller"
application.register("slug", SlugController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SwitchController from "./switch_controller"
application.register("switch", SwitchController)

import TemplateController from "./template_controller"
application.register("template", TemplateController)

import TemplateFakeDestroyController from "./template_fake_destroy_controller"
application.register("template-fake-destroy", TemplateFakeDestroyController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleRadioController from "./toggle_radio_controller"
application.register("toggle-radio", ToggleRadioController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
